import { createTRPCReact } from "@trpc/react-query";
import type { AppRouter } from "@/server/trpc";

/**
 * tRPC React Client
 *
 * Creates typed React hooks for tRPC procedures.
 * Usage: trpc.hello.greet.useQuery()
 */
export const trpc = createTRPCReact<AppRouter>();

/**
 * Get Base URL
 *
 * Returns the base URL for tRPC requests.
 * Handles both browser and server-side rendering.
 */
export function getBaseUrl(): string {
  // Browser: use relative URL
  if (typeof window !== "undefined") {
    return "";
  }

  // Vercel deployment
  if (process.env.VERCEL_URL) {
    return `https://${process.env.VERCEL_URL}`;
  }

  // Railway deployment
  if (process.env.RAILWAY_PUBLIC_DOMAIN) {
    return `https://${process.env.RAILWAY_PUBLIC_DOMAIN}`;
  }

  // Local development
  return `http://localhost:${process.env.PORT ?? 4000}`;
}
